var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Petty Cash Features")]),_c('p',[_vm._v("Discover the features of our Petty Cash management system.")])])
}]

export { render, staticRenderFns }